import { fillOptInTemplate, optInTemplateValues } from "./optInGate";
import { formatEmbedList, getEmbedTypes } from "./embedInventory";

export const CONSENT_DEFAULT_COPY = {
  title: "Cookie and Privacy Preferences",
  intro: "Skip the searching. Choose your path and go straight to the content that matters most to you.",
  essential_only: "Essential Only",
  essential_only_label: "Essential Only:",
  essential_only_detail: "Read, navigate, and provide feedback.",
  accept_all: "Accept All",
  accept_all_label: "Accept All:",
  accept_all_detail_embeds:
    "Also enables third-party content ({{embed_list}}) and lets {{sender_company}} (the organization that shared this link) see how you engage with the content.",
  accept_all_detail:
    "Also lets {{sender_company}} (the organization that shared this link) see how you engage with the content.",
  privacy_notice: "Privacy Notice",
  withdraw: "You can withdraw consent at any time via the Privacy icon.",
  gpc_notice: "Your browser sends a Global Privacy Control signal, so only essential cookies are used.",
  ai_notice: "Questions you ask here are shared with {{sender_company}}.",
  close: "Close",
  embed_types: {
    video: "video",
    audio: "audio",
    live_chat: "live chat",
    maps: "interactive maps",
    forms: "forms",
    ai_assistant: "AI assistant",
    images: "external images",
    web_content: "embedded web pages",
  },
};

export const CONSENT_BANNER_TITLE = CONSENT_DEFAULT_COPY.title;

export const CONSENT_WITHDRAW_STATEMENT = CONSENT_DEFAULT_COPY.withdraw;

export const CONSENT_GPC_NOTICE = CONSENT_DEFAULT_COPY.gpc_notice;

export const CONSENT_TEXT_VARIABLES = ["sender_company", "sender_first_name"];

export const CONSENT_TEXT_MAX_LENGTH = 500;

export const buildConsentSections = ({
  copy = CONSENT_DEFAULT_COPY,
  values = optInTemplateValues(window?.objInit?.tlb),
  embedTypes = getEmbedTypes(),
  locale = "en",
} = {}) => {
  const strings = { ...CONSENT_DEFAULT_COPY, ...(copy || {}) };
  const embedList = formatEmbedList(embedTypes, strings.embed_types, locale);
  const fill = (text) => fillOptInTemplate(text, { ...values, embed_list: embedList });
  const labelSeparator = (label) => (/：$/.test(label || "") ? "" : " ");
  return [
    { key: "intro", text: fill(strings.intro) },
    {
      key: "essential",
      label: strings.essential_only_label,
      separator: labelSeparator(strings.essential_only_label),
      text: fill(strings.essential_only_detail),
    },
    {
      key: "accept",
      label: strings.accept_all_label,
      separator: labelSeparator(strings.accept_all_label),
      text: fill(embedList ? strings.accept_all_detail_embeds : strings.accept_all_detail),
    },
    ...((embedTypes || []).includes("ai_assistant") ? [{ key: "ai", text: fill(strings.ai_notice) }] : []),
  ];
};

export const consentPlainText = (sections) =>
  sections.map((section) => (section.label ? `${section.label}${section.separator ?? " "}${section.text}` : section.text)).join("\n");
